import { escapeHtml, readMatchPairs } from './markup';

const shuffle = (items) => {
  const next = [...items];
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
};

const bindAccordion = (root) => {
  root.querySelectorAll('.mc-accordion, [data-mc-widget="accordion"]').forEach((widget) => {
    if (widget.dataset.mcBound === '1') {
      return;
    }
    widget.dataset.mcBound = '1';
    const firstItem = widget.querySelector('.mc-accordion__item');
    if (firstItem) {
      firstItem.classList.add('is-open');
    }
    widget.addEventListener('click', (event) => {
      if (event.target.closest('[data-mc-edit], [data-mc-chrome]')) {
        return;
      }
      const header = event.target.closest('[data-mc-accordion-toggle]');
      if (!header || !widget.contains(header)) {
        return;
      }
      const item = header.closest('.mc-accordion__item');
      if (!item) {
        return;
      }
      const isOpen = item.classList.contains('is-open');
      widget
        .querySelectorAll('.mc-accordion__item.is-open')
        .forEach((openItem) => openItem.classList.remove('is-open'));
      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });
};

const bindFlipCards = (root) => {
  root.querySelectorAll('.mc-flipcard, [data-mc-widget="flipcard"]').forEach((widget) => {
    if (widget.dataset.mcBound === '1') {
      return;
    }
    widget.dataset.mcBound = '1';
    widget.addEventListener('click', (event) => {
      if (event.target.closest('[data-mc-edit]')) {
        return;
      }
      widget.classList.toggle('is-flipped');
    });
    widget.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        widget.classList.toggle('is-flipped');
      }
    });
    widget.setAttribute('tabindex', '0');
    widget.setAttribute('role', 'button');
  });
};

const bindMatch = (root, { shuffleDefs = true } = {}) => {
  root.querySelectorAll('.mc-match, [data-mc-widget="match"]').forEach((widget) => {
    if (widget.dataset.mcBound === '1') {
      return;
    }
    widget.dataset.mcBound = '1';
    const pairs = readMatchPairs(widget);
    const defsCol = widget.querySelector('.mc-match__defs');
    if (!defsCol || !pairs.length) {
      return;
    }

    const ordered = pairs.map((pair, index) => ({ ...pair, id: String(index) }));
    const shuffled = shuffleDefs ? shuffle(ordered) : ordered;
    defsCol.innerHTML = shuffled
      .map(
        (pair) =>
          `<div class="mc-match__def" draggable="true" data-match-id="${
            pair.id
          }">${escapeHtml(pair.definition)}</div>`,
      )
      .join('');

    let dragId = null;

    widget.addEventListener('dragstart', (event) => {
      const def = event.target.closest('.mc-match__def');
      if (!def) {
        return;
      }
      dragId = def.getAttribute('data-match-id');
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', dragId);
    });

    widget.querySelectorAll('.mc-match__term').forEach((term) => {
      term.addEventListener('dragover', (event) => {
        event.preventDefault();
        term.classList.add('is-over');
      });
      term.addEventListener('dragleave', () => {
        term.classList.remove('is-over');
      });
      term.addEventListener('drop', (event) => {
        event.preventDefault();
        term.classList.remove('is-over');
        const droppedId =
          event.dataTransfer.getData('text/plain') || dragId;
        const termId = term.getAttribute('data-match-id');
        const def = widget.querySelector(
          `.mc-match__def[data-match-id="${droppedId}"]`,
        );
        if (!def) {
          return;
        }
        const correct = droppedId === termId;
        term.classList.toggle('is-correct', correct);
        term.classList.toggle('is-wrong', !correct);
        def.classList.toggle('is-correct', correct);
        def.classList.toggle('is-wrong', !correct);
        if (correct) {
          def.setAttribute('draggable', 'false');
        }
      });
    });
  });
};

export const hydrateInteractiveWidgets = (
  root,
  { stripChrome = true, shuffleMatch = true } = {},
) => {
  if (!root) {
    return;
  }
  if (stripChrome) {
    root.querySelectorAll('[data-mc-chrome]').forEach((el) => el.remove());
  }
  bindAccordion(root);
  bindFlipCards(root);
  bindMatch(root, { shuffleDefs: shuffleMatch });
};
